import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const maps = {
  'imagine-fest': {
    zones: {
      general: { name: 'Zona general' },
      vip: { name: 'Zona VIP' },
      reservado: { name: 'Reservado' }
    }
  }
};

function ImagineFestMap({ selectedZone, onSelectZone, reservadoSold = 0, reservadoCapacity = 5 }) {
  const boxCount = reservadoCapacity;
  const boxHeight = 18;
  const boxGap = 4;
  const startY = 32;
  const boxWidth = 198;

  return (
    <svg viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto', display: 'block' }}>
      <rect width="600" height="600" fill="#111" rx="14"/>

      <rect x="30" y="30" width="540" height="500" rx="30" fill="#222" stroke="#444" strokeWidth="2"/>

      {/* GENERAL */}
      <rect
        x="32" y="32" width="536" height="496" rx="28"
        fill="#1e7acc" fillOpacity="0.85"
        stroke={selectedZone === 'general' ? '#fff' : '#55bbff'}
        strokeWidth={selectedZone === 'general' ? 3 : 2}
        style={{ cursor: 'pointer', transition: 'opacity 0.15s' }}
        onClick={() => onSelectZone('general')}
      />

      {/* RESERVADO — 5 cajas individuales, 150€ cada una */}
      {Array.from({ length: boxCount }).map((_, i) => {
        const isSold = i < reservadoSold;
        const y = startY + i * (boxHeight + boxGap);
        return (
          <g key={`reservado-${i}`}>
            <rect
              x="370" y={y} width={boxWidth} height={boxHeight}
              fill={isSold ? '#333' : '#5a1a7a'}
              fillOpacity={isSold ? 0.6 : 0.92}
              stroke={isSold ? '#555' : (selectedZone === 'reservado' ? '#fff' : '#bb55ee')}
              strokeWidth={!isSold && selectedZone === 'reservado' ? 3 : 1.5}
              style={{ cursor: isSold ? 'default' : 'pointer' }}
              onClick={() => !isSold && onSelectZone('reservado')}
            />
            <text
              x="469" y={y + 13}
              textAnchor="middle" fontSize="10"
              fill={isSold ? '#888' : '#e0b0ff'}
              fontFamily="sans-serif" pointerEvents="none"
            >
              {isSold ? 'VENDIDO' : `Reservado ${i + 1} — 150€`}
            </text>
          </g>
        );
      })}
      <text x="469" y={startY + boxCount * (boxHeight + boxGap) + 12} textAnchor="middle" fontSize="10" fill="#00cc66" fontFamily="sans-serif" pointerEvents="none">
        ● {reservadoCapacity - reservadoSold}/{reservadoCapacity} disponibles · Incluye 1 botella
      </text>

      {/* ESCENARIO */}
      <rect x="180" y="85" width="145" height="95" rx="8" fill="#ececec" stroke="#ffffff" strokeWidth="2"/>
      <text x="252" y="128" textAnchor="middle" fontSize="13" fill="#333" fontFamily="sans-serif" pointerEvents="none">ESCENARIO</text>
      <text x="252" y="148" textAnchor="middle" fontSize="11" fill="#666" fontFamily="sans-serif" pointerEvents="none">DJ</text>

      {/* VIP */}
      <rect
        x="370" y="410" width="198" height="118"
        fill="#1a7a1a" fillOpacity="0.92"
        stroke={selectedZone === 'vip' ? '#fff' : '#44dd44'}
        strokeWidth={selectedZone === 'vip' ? 3 : 2}
        style={{ cursor: 'pointer', transition: 'opacity 0.15s' }}
        onClick={() => onSelectZone('vip')}
      />
      <rect x="430" y="428" width="100" height="82" rx="6" fill="#3a2008" stroke="#5a3a18" strokeWidth="1.5" pointerEvents="none"/>
      <text x="400" y="475" textAnchor="middle" fontSize="13" fill="#88ff88" fontFamily="sans-serif" pointerEvents="none">VIP</text>

      {/* Entrada */}
      <rect x="80" y="512" width="110" height="26" rx="8" fill="#333" stroke="#555" strokeWidth="1.5"/>
      <text x="135" y="529" textAnchor="middle" fontSize="10" fill="#aaa" fontFamily="sans-serif" pointerEvents="none">ENTRADA</text>

      {/* Etiqueta General */}
      <text x="200" y="400" textAnchor="middle" fontSize="16" fill="#aaddff" fillOpacity="0.5" fontFamily="sans-serif" pointerEvents="none">GENERAL</text>

      {/* Leyenda */}
      <rect x="20" y="548" width="11" height="11" rx="2" fill="#5a1a7a" stroke="#bb55ee" strokeWidth="1"/>
      <text x="35" y="558" fontSize="10" fill="#777" fontFamily="sans-serif">Reservado</text>
      <rect x="120" y="548" width="11" height="11" rx="2" fill="#333" stroke="#555" strokeWidth="1"/>
      <text x="135" y="558" fontSize="10" fill="#777" fontFamily="sans-serif">Vendido</text>
      <rect x="205" y="548" width="11" height="11" rx="2" fill="#1a7a1a" stroke="#44dd44" strokeWidth="1"/>
      <text x="220" y="558" fontSize="10" fill="#777" fontFamily="sans-serif">VIP</text>
      <rect x="255" y="548" width="11" height="11" rx="2" fill="#1e7acc" stroke="#55bbff" strokeWidth="1"/>
      <text x="270" y="558" fontSize="10" fill="#777" fontFamily="sans-serif">General</text>
      <rect x="325" y="548" width="11" height="11" rx="2" fill="#ececec" stroke="#fff" strokeWidth="1"/>
      <text x="340" y="558" fontSize="10" fill="#777" fontFamily="sans-serif">Escenario</text>
    </svg>
  );
}

function RecintoMap({ venueMap, ticketTypes = [] }) {
  const { colors } = useTheme();
  const [selectedZone, setSelectedZone] = useState(null);

  const mapConfig = maps[venueMap];
  if (!mapConfig) return null;

  const reservadoType = ticketTypes.find(tt => tt.is_backstage);
  const reservadoSold = reservadoType?.sold || 0;
  const reservadoCapacity = reservadoType?.capacity || 5;

  const getOpts = (zoneId) => {
    if (zoneId === 'general') {
      const generalTypes = ticketTypes.filter(tt => !tt.is_vip && !tt.is_backstage);
      const currentPosition = generalTypes.find(tt => tt.sold < tt.capacity)?.order_position;
      return generalTypes
        .filter(tt => tt.order_position === currentPosition ||
          (currentPosition && tt.order_position === currentPosition + 1 &&
            tt.includes_bus &&
            !generalTypes.find(t => t.order_position === currentPosition)?.includes_bus))
        .filter(tt => tt.sold < tt.capacity)
        .map(tt => ({
          id: String(tt.id),
          label: tt.name,
          badge: `${tt.capacity - tt.sold} disponibles`,
          price: parseFloat(tt.price) + '€',
          inc: tt.description
        }));
    }
    if (zoneId === 'vip') {
      return ticketTypes
        .filter(tt => tt.is_vip && tt.sold < tt.capacity)
        .map(tt => ({
          id: String(tt.id),
          label: tt.name,
          badge: `${tt.capacity - tt.sold} disponibles`,
          price: parseFloat(tt.price) + '€',
          inc: tt.description
        }));
    }
    if (zoneId === 'reservado') {
      return ticketTypes
        .filter(tt => tt.is_backstage && tt.sold < tt.capacity)
        .map(tt => ({
          id: String(tt.id),
          label: tt.name,
          badge: `${tt.capacity - tt.sold} disponibles`,
          price: parseFloat(tt.price) + '€',
          inc: tt.description
        }));
    }
    return [];
  };

  const zoneName = selectedZone ? mapConfig.zones[selectedZone]?.name : null;
  const opts = selectedZone ? getOpts(selectedZone) : [];

  return (
    <div>
      <div style={{ maxWidth: '560px', margin: '0 auto 1.5rem' }}>
        <ImagineFestMap
          selectedZone={selectedZone}
          onSelectZone={setSelectedZone}
          reservadoSold={reservadoSold}
          reservadoCapacity={reservadoCapacity}
        />
      </div>

      <div style={{
        backgroundColor: colors.bgTertiary,
        borderRadius: '12px',
        border: `1px solid ${colors.border}`,
        padding: '1.25rem',
        minHeight: '80px'
      }}>
        {!selectedZone ? (
          <p style={{ color: colors.textSecondary, fontSize: '14px', textAlign: 'center', margin: '1rem 0' }}>
            Haz clic en una zona del mapa para ver opciones y precios
          </p>
        ) : opts.length === 0 ? (
          <p style={{ color: colors.textSecondary, fontSize: '14px', textAlign: 'center', margin: '1rem 0' }}>
            No quedan entradas disponibles para esta zona
          </p>
        ) : (
          <div>
            <p style={{ color: colors.text, fontWeight: 'bold', fontSize: '16px', marginBottom: '0.75rem' }}>{zoneName}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {opts.map(opt => (
                <div key={opt.id} style={{
                  backgroundColor: colors.bgSecondary,
                  border: `0.5px solid ${colors.border}`,
                  borderRadius: '8px',
                  padding: '10px 14px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                    <span style={{ color: colors.text, fontWeight: '500', fontSize: '13px' }}>{opt.label}</span>
                    <span style={{
                      fontSize: '10px',
                      backgroundColor: colors.bgTertiary,
                      color: colors.accent,
                      padding: '2px 7px',
                      borderRadius: '6px',
                      display: 'inline-block',
                      width: 'fit-content'
                    }}>{opt.badge}</span>
                    <span style={{ color: colors.textSecondary, fontSize: '11px' }}>{opt.inc}</span>
                  </div>
                  <span style={{ color: colors.text, fontWeight: '500', fontSize: '14px', whiteSpace: 'nowrap' }}>{opt.price}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecintoMap;